var map = {
	"./production_upsell_apply_discount_fallback.json": [
		631,
		631
	],
	"./production_upsell_new_h_2_fallback.json": [
		64144,
		4144
	],
	"./production_upsell_new_h_fallback.json": [
		40660,
		660
	],
	"./production_upsell_new_t_fallback.json": [
		95248,
		5248
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21296;
module.exports = webpackAsyncContext;